import { render } from "./updateLog.vue?vue&type=template&id=04b8fcbb&scoped=true"
import script from "./updateLog.vue?vue&type=script&lang=ts"
export * from "./updateLog.vue?vue&type=script&lang=ts"

import "./updateLog.vue?vue&type=style&index=0&id=04b8fcbb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04b8fcbb"

export default script